export const LANGS = ['engb', 'id', 'cn', 'th'];
